// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"444":"78a91f4d","862":"ce85b2bc"}[chunkId] + ".chunk.css";
};